module.exports = __webpack_public_path__ + "img/07.e6b623f7.jpg";